import { useState, useEffect, useCallback } from 'react';

// This hook is only active when url is defined. If not it returns { loaded: true, preloaded: true , ... }
const useImgLazyLoad = (
  url?: string,
): { loaded: boolean; onLoaded: () => void; preloaded: boolean } => {
  const [loaded, setLoaded] = useState(url === undefined);
  const [preloaded, setPreloaded] = useState(url === undefined);

  const onLoaded = useCallback(() => setLoaded(true), [setLoaded]);
  useEffect(() => {
    if (url === undefined) return;
    const lowImg = new Image();
    lowImg.src = url;
    lowImg.onload = () => setPreloaded(true);

    return () => {
      lowImg.onload = null;
    };
  }, [url, setPreloaded]);

  return { loaded, preloaded, onLoaded };
};

export default useImgLazyLoad;
